import * as analyticsService from "@store/Services/AnalyticsService";

const useAnalytics = () => {
    return analyticsService;
};

export default useAnalytics;
